/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Closing_NoteInputs */

const en_home_closing_note = /** @type {(inputs: Home_Closing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 30-minute conversation. No technical brief needed.`)
};

const lv_home_closing_note = /** @type {(inputs: Home_Closing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 minūšu saruna. Tehnisks apraksts nav vajadzīgs.`)
};

/**
* | output |
* | --- |
* | "A 30-minute conversation. No technical brief needed." |
*
* @param {Home_Closing_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_closing_note = /** @type {((inputs?: Home_Closing_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Closing_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_closing_note(inputs)
	return en_home_closing_note(inputs)
});